import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=201186c2&scoped=true"
import script from "./logDetail.vue?vue&type=script&lang=js"
export * from "./logDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201186c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201186c2')) {
      api.createRecord('201186c2', component.options)
    } else {
      api.reload('201186c2', component.options)
    }
    module.hot.accept("./logDetail.vue?vue&type=template&id=201186c2&scoped=true", function () {
      api.rerender('201186c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/dangaoOrder/logDetail.vue"
export default component.exports